import type { WvEnvelope, WvHostEvent } from './types';

let webviewMode = false;

export const setWebviewMode = (on: boolean) => {
  webviewMode = on;
};

export const isWebview = () => webviewMode;

export const postToHost = (event: WvHostEvent) => {
  const channel = globalThis.BhanzuBridge;
  const envelope: WvEnvelope = { v: 1, ...event };

  if (channel?.postMessage) {
    channel.postMessage(JSON.stringify(envelope));
    return;
  }

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.warn('[webview-bridge] host channel missing', envelope);
  }
};
